/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

require('../../modules/es6.reflect.delete-property');
module.exports = require('../../modules/_core').Reflect.deleteProperty;




//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/reflect/delete-property.js
// module id = 1082
// module chunks = 60